/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DtmPrenosSouborVO } from '../model';
// @ts-ignore
import { DtmPrenosVO } from '../model';
// @ts-ignore
import { DtmPrenosZarizeniVO } from '../model';
// @ts-ignore
import { GridDtmPrenosVO } from '../model';
// @ts-ignore
import { GridDtmPrenosZarizeniVO } from '../model';
// @ts-ignore
import { GridFilterDtmPrenosVO } from '../model';
// @ts-ignore
import { GridFilterDtmPrenosZarizeniVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * MapioDtmControllerApi - axios parameter creator
 * @export
 */
export const MapioDtmControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {GridFilterDtmPrenosVO} [gridFilterDtmPrenosVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrenosByFilter: async (gridFilterDtmPrenosVO?: DataRequestVO<Objs.GridFilterDtmPrenosVOGrid>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dtm/prenos/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridFilterDtmPrenosVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {number} idPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {GridFilterDtmPrenosZarizeniVO} [gridFilterDtmPrenosZarizeniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrenosZarizeniByFilter: async (idPrenos: number, gridFilterDtmPrenosZarizeniVO?: DataRequestVO<Objs.GridFilterDtmPrenosZarizeniVOGrid>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPrenos' is not null or undefined
            assertParamExists('findPrenosZarizeniByFilter', 'idPrenos', idPrenos)
            const localVarPath = `/api/dtm/zarizeni/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPrenos !== undefined) {
                localVarQueryParameter['idPrenos'] = idPrenos;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridFilterDtmPrenosZarizeniVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Načte detail přenosu DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosDtm: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrenosDtm', 'id', id)
            const localVarPath = `/api/dtm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací soubor z výsledku přenosu do DTM podle id souboru (Mapio_DTM_Prenos_soubor).
         * @param {number} idDtmPrenosSoubor ID stahovaného souboru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosSoubor: async (idDtmPrenosSoubor: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDtmPrenosSoubor' is not null or undefined
            assertParamExists('getPrenosSoubor', 'idDtmPrenosSoubor', idDtmPrenosSoubor)
            const localVarPath = `/api/dtm/prenos/soubor/{idDtmPrenosSoubor}`
                .replace(`{${"idDtmPrenosSoubor"}}`, encodeURIComponent(String(idDtmPrenosSoubor)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idDtmPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosSouborByIdPrenos: async (idDtmPrenos: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDtmPrenos' is not null or undefined
            assertParamExists('getPrenosSouborByIdPrenos', 'idDtmPrenos', idDtmPrenos)
            const localVarPath = `/api/dtm/prenos/{idDtmPrenos}/soubory`
                .replace(`{${"idDtmPrenos"}}`, encodeURIComponent(String(idDtmPrenos)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Načte seznam synchronizací DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynchronizaceDtm: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSynchronizaceDtm', 'id', id)
            const localVarPath = `/api/dtm/{id}/zarizeni`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapioDtmControllerApi - functional programming interface
 * @export
 */
export const MapioDtmControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapioDtmControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {GridFilterDtmPrenosVO} [gridFilterDtmPrenosVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPrenosByFilter(gridFilterDtmPrenosVO?: DataRequestVO<Objs.GridFilterDtmPrenosVOGrid>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataResponseVO<Objs.GridDtmPrenosVOGrid>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findPrenosByFilter(gridFilterDtmPrenosVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {number} idPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {GridFilterDtmPrenosZarizeniVO} [gridFilterDtmPrenosZarizeniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPrenosZarizeniByFilter(idPrenos: number, gridFilterDtmPrenosZarizeniVO?: DataRequestVO<Objs.GridFilterDtmPrenosZarizeniVOGrid>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataResponseVO<Objs.GridDtmPrenosZarizeniVOGrid>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findPrenosZarizeniByFilter(idPrenos, gridFilterDtmPrenosZarizeniVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Načte detail přenosu DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrenosDtm(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DtmPrenosVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrenosDtm(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrací soubor z výsledku přenosu do DTM podle id souboru (Mapio_DTM_Prenos_soubor).
         * @param {number} idDtmPrenosSoubor ID stahovaného souboru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrenosSoubor(idDtmPrenosSoubor: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrenosSoubor(idDtmPrenosSoubor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idDtmPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrenosSouborByIdPrenos(idDtmPrenos: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DtmPrenosSouborVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrenosSouborByIdPrenos(idDtmPrenos, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Načte seznam synchronizací DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynchronizaceDtm(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DtmPrenosZarizeniVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getSynchronizaceDtm(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MapioDtmControllerApi - factory interface
 * @export
 */
export const MapioDtmControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapioDtmControllerApiFp(configuration)
    return {
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {GridFilterDtmPrenosVO} [gridFilterDtmPrenosVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrenosByFilter(gridFilterDtmPrenosVO?: DataRequestVO<Objs.GridFilterDtmPrenosVOGrid>, options?: any): AxiosPromise<DataResponseVO<Objs.GridDtmPrenosVOGrid>> {
            return localVarFp.findPrenosByFilter(gridFilterDtmPrenosVO, options).then((request) => request(axios, basePath));
        },
        /**
         * vyhledávání podle filtru v seznamu přenosu DTM
         * @param {number} idPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {GridFilterDtmPrenosZarizeniVO} [gridFilterDtmPrenosZarizeniVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPrenosZarizeniByFilter(idPrenos: number, gridFilterDtmPrenosZarizeniVO?: DataRequestVO<Objs.GridFilterDtmPrenosZarizeniVOGrid>, options?: any): AxiosPromise<DataResponseVO<Objs.GridDtmPrenosZarizeniVOGrid>> {
            return localVarFp.findPrenosZarizeniByFilter(idPrenos, gridFilterDtmPrenosZarizeniVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Načte detail přenosu DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosDtm(id: number, options?: any): AxiosPromise<DtmPrenosVO> {
            return localVarFp.getPrenosDtm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací soubor z výsledku přenosu do DTM podle id souboru (Mapio_DTM_Prenos_soubor).
         * @param {number} idDtmPrenosSoubor ID stahovaného souboru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosSoubor(idDtmPrenosSoubor: number, options?: any): AxiosPromise<File> {
            return localVarFp.getPrenosSoubor(idDtmPrenosSoubor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idDtmPrenos ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrenosSouborByIdPrenos(idDtmPrenos: number, options?: any): AxiosPromise<Array<DtmPrenosSouborVO>> {
            return localVarFp.getPrenosSouborByIdPrenos(idDtmPrenos, options).then((request) => request(axios, basePath));
        },
        /**
         * Načte seznam synchronizací DTM
         * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynchronizaceDtm(id: number, options?: any): AxiosPromise<Array<DtmPrenosZarizeniVO>> {
            return localVarFp.getSynchronizaceDtm(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapioDtmControllerApi - interface
 * @export
 * @interface MapioDtmControllerApi
 */
export interface MapioDtmControllerApiInterface {
    /**
     * vyhledávání podle filtru v seznamu přenosu DTM
     * @param {GridFilterDtmPrenosVO} [gridFilterDtmPrenosVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    findPrenosByFilter(gridFilterDtmPrenosVO?: DataRequestVO<Objs.GridFilterDtmPrenosVOGrid>, options?: any): AxiosPromise<DataResponseVO<Objs.GridDtmPrenosVOGrid>>;

    /**
     * vyhledávání podle filtru v seznamu přenosu DTM
     * @param {number} idPrenos ID DTM přenos (Mapio_DTM_Prenos)
     * @param {GridFilterDtmPrenosZarizeniVO} [gridFilterDtmPrenosZarizeniVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    findPrenosZarizeniByFilter(idPrenos: number, gridFilterDtmPrenosZarizeniVO?: DataRequestVO<Objs.GridFilterDtmPrenosZarizeniVOGrid>, options?: any): AxiosPromise<DataResponseVO<Objs.GridDtmPrenosZarizeniVOGrid>>;

    /**
     * Načte detail přenosu DTM
     * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    getPrenosDtm(id: number, options?: any): AxiosPromise<DtmPrenosVO>;

    /**
     * Vrací soubor z výsledku přenosu do DTM podle id souboru (Mapio_DTM_Prenos_soubor).
     * @param {number} idDtmPrenosSoubor ID stahovaného souboru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    getPrenosSoubor(idDtmPrenosSoubor: number, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {number} idDtmPrenos ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    getPrenosSouborByIdPrenos(idDtmPrenos: number, options?: any): AxiosPromise<Array<DtmPrenosSouborVO>>;

    /**
     * Načte seznam synchronizací DTM
     * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApiInterface
     */
    getSynchronizaceDtm(id: number, options?: any): AxiosPromise<Array<DtmPrenosZarizeniVO>>;

}

/**
 * MapioDtmControllerApi - object-oriented interface
 * @export
 * @class MapioDtmControllerApi
 * @extends {BaseAPI}
 */
export class MapioDtmControllerApi extends BaseAPI implements MapioDtmControllerApiInterface {
    /**
     * vyhledávání podle filtru v seznamu přenosu DTM
     * @param {GridFilterDtmPrenosVO} [gridFilterDtmPrenosVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public findPrenosByFilter(gridFilterDtmPrenosVO?: DataRequestVO<Objs.GridFilterDtmPrenosVOGrid>, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).findPrenosByFilter(gridFilterDtmPrenosVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * vyhledávání podle filtru v seznamu přenosu DTM
     * @param {number} idPrenos ID DTM přenos (Mapio_DTM_Prenos)
     * @param {GridFilterDtmPrenosZarizeniVO} [gridFilterDtmPrenosZarizeniVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public findPrenosZarizeniByFilter(idPrenos: number, gridFilterDtmPrenosZarizeniVO?: DataRequestVO<Objs.GridFilterDtmPrenosZarizeniVOGrid>, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).findPrenosZarizeniByFilter(idPrenos, gridFilterDtmPrenosZarizeniVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Načte detail přenosu DTM
     * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public getPrenosDtm(id: number, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).getPrenosDtm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací soubor z výsledku přenosu do DTM podle id souboru (Mapio_DTM_Prenos_soubor).
     * @param {number} idDtmPrenosSoubor ID stahovaného souboru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public getPrenosSoubor(idDtmPrenosSoubor: number, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).getPrenosSoubor(idDtmPrenosSoubor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idDtmPrenos ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public getPrenosSouborByIdPrenos(idDtmPrenos: number, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).getPrenosSouborByIdPrenos(idDtmPrenos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Načte seznam synchronizací DTM
     * @param {number} id ID DTM přenos (Mapio_DTM_Prenos)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapioDtmControllerApi
     */
    public getSynchronizaceDtm(id: number, options?: any) {
        return MapioDtmControllerApiFp(this.configuration).getSynchronizaceDtm(id, options).then((request) => request(this.axios, this.basePath));
    }
}
